// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2PlhQ","selects":"Documents_selects__u2ua0"};